import { useState } from 'react'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusPopOver } from '@rhybus/popover'
import { RhyBusTextArea } from '@rhybus/form-controls'
import { approveCase } from '../../../services/detailview'
import { ACTIVITY_ID, triggerCaseNotifications } from '../../../services/notificationUtils'
import { STATUS_CODE } from '../../../config/configuration'

type ApproveButtonProps = {
    caseGUID: string
    caseID: string
    userCaseId: string
    currentStatusCode: number | null
    userRole: string
    me: any
    onSuccess?: () => void
}

export default function ApproveButton({ caseGUID, caseID, userCaseId, currentStatusCode, userRole, me, onSuccess }: ApproveButtonProps) {
    const [visible, setVisible] = useState(false)
    const [comment, setComment] = useState('')
    const [commentError, setCommentError] = useState('')
    const [loading, setLoading] = useState(false)

    const handleOk = async () => {
        if (!comment.trim()) {
            setCommentError('Comments are required')
            return
        }
        setLoading(true)
        const success = await approveCase(caseGUID, caseID, comment, currentStatusCode, userRole, me)
        await triggerCaseNotifications(
            caseGUID,
            `Case ${userCaseId || caseID} has been approved by ${me?.profileName}`,
            ACTIVITY_ID.CASE_Approve,
            STATUS_CODE.WaitingforDSCAFunding,
            me?.email,
        )

        setLoading(false)
        if (success) {
            setVisible(false)
            setComment('')
            setCommentError('')
            onSuccess?.()
        }
    }

    return (
        <RhyBusPopOver
            placement="bottom-left"
            trigger="click"
            popoverclassName="detail-view-approve-popover action-btn-popover popup-md"
            visible={visible}
            onVisibleChange={setVisible}
            content={
                <div className="d-flex flex-column gap-3 detail-view-popover-form">
                    <RhyBusTextArea
                        id="approve-comments"
                        label="Comments"
                        value={comment}
                        rows={6}
                        isMandatory
                        error={commentError ? true : false}
                        errorMessage={commentError ? commentError : ''}
                        placeholder="Enter comments"
                        labelClassName='inter-medium font-14'
                        info="Add notes for the selected status update"
                        tooltipPlacement="top"
                        onChange={(e: any) => {
                            setComment(e.target.value)
                            if (e.target.value.trim()) setCommentError('')
                        }}
                    />
                </div>
            }
            footer={
                <div className="d-flex justify-content-end gap-2">
                    <RhyBusButton label="Ok" variant="primary" leftIcon='icon-rb-checked' size="md"
                        onClick={handleOk}
                        disabled={loading}
                    />
                    <RhyBusButton label="Cancel" variant="primary" leftIcon='icon-rb-close color-primary font-10' size="md"
                        onClick={() => { setVisible(false); setComment(''); setCommentError('') }}
                        style={{ '--rb-btn-bg': '#FFFFFF', '--rb-btn-border': '#BACBD9', '--rb-btn-text': '#596F80', '--rb-btn-hover-bg': '#fff', '--rb-btn-active-bg': '#fff', '--rb-btn-hover-border': '#BACBD9' }}
                    />
                </div>
            }
        >
            <RhyBusButton
                label="Approve"
                leftIcon="icon-rb-checked font-16"
                variant="primary"
                pill={true}
                className='approve-button'
                ariaLabel="Approve"
                style={{ '--rb-btn-bg': '#627906' }}
            />
        </RhyBusPopOver>
    )
}
